import { Box, VStack, Text, Heading, keyframes } from '@chakra-ui/react';

// Animation keyframes
const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

export const MaintenancePage = () => {
  return (
    <Box
      minH='100vh'
      display='flex'
      alignItems='center'
      justifyContent='center'
      bg='linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      px={4}
      position='relative'
      overflow='hidden'
    >
      {/* Animated background elements */}
      <Box
        position='absolute'
        top='10%'
        left='10%'
        w='100px'
        h='100px'
        bg='rgba(255,255,255,0.1)'
        rounded='full'
        animation={`${pulse} 3s ease-in-out infinite`}
      />
      <Box
        position='absolute'
        bottom='20%'
        right='15%'
        w='150px'
        h='150px'
        bg='rgba(255,255,255,0.05)'
        rounded='full'
        animation={`${pulse} 4s ease-in-out infinite`}
      />

      <Box maxW='2xl' w='full' textAlign='center' position='relative' zIndex={1}>
        <Box
          bg='white'
          rounded='2xl'
          shadow='2xl'
          p={12}
          border='1px solid'
          borderColor='rgba(255,255,255,0.2)'
          backdropFilter='blur(10px)'
        >
          {/* Header */}
          <VStack mb={8}>
            <Box
              w='24'
              h='24'
              bg='linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)'
              rounded='full'
              display='flex'
              alignItems='center'
              justifyContent='center'
              mx='auto'
              boxShadow='0 10px 30px rgba(255, 107, 107, 0.3)'
              animation={`${pulse} 2s ease-in-out infinite`}
            >
              <Box
                as='svg'
                w='12'
                h='12'
                color='white'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z'
                />
              </Box>
            </Box>
          </VStack>

          {/* Main Title */}
          <Heading
            as='h1'
            size='2xl'
            color='gray.800'
            mb={8}
            fontWeight='bold'
            textShadow='0 2px 4px rgba(0,0,0,0.1)'
          >
            🚧 تحت الصيانة 🚧
          </Heading>
          <Heading
            as='h1'
            size='xl'
            color='gray.800'
            mb={8}
            fontWeight='bold'
            textShadow='0 2px 4px rgba(0,0,0,0.1)'
          >
            🚧 Under Maintenance 🚧
          </Heading>

          {/* Messages with Blurred Background */}
          <VStack spacing={6} align='stretch' mb={8}>
            {/* Arabic Message First */}
            <Box
              bg='rgba(34, 197, 94, 0.1)'
              p={6}
              rounded='xl'
              border='2px solid'
              borderColor='rgba(34, 197, 94, 0.3)'
              backdropFilter='blur(10px)'
            >
              <Text fontSize='xl' color='green.800' lineHeight='relaxed' fontWeight='medium' mb={3}>
                صيانة مؤقتة
              </Text>
              <Text fontSize='lg' color='green.700' lineHeight='relaxed' fontWeight='medium'>
                اهلا اصدقائنا, منصة تكت تحت صيانة مؤقتة, ستعود المنصة للعمل قريباً. الرجاء المحاولة
                لاحقاً
              </Text>
            </Box>

            {/* English Message Second */}
            <Box
              bg='rgba(59, 130, 246, 0.1)'
              p={6}
              rounded='xl'
              border='2px solid'
              borderColor='rgba(59, 130, 246, 0.3)'
              backdropFilter='blur(10px)'
            >
              <Text fontSize='xl' color='blue.800' lineHeight='relaxed' fontWeight='medium' mb={3}>
                Temporary Maintenance
              </Text>
              <Text fontSize='lg' color='blue.700' lineHeight='relaxed' fontWeight='medium'>
                Hello friends, Ticket Zone platform is under temporary maintenance check, we will be
                back soon!
              </Text>
            </Box>
          </VStack>

          {/* Footer */}
          <Box
            bg='rgba(107, 114, 128, 0.1)'
            p={4}
            rounded='lg'
            border='1px solid'
            borderColor='rgba(107, 114, 128, 0.3)'
            backdropFilter='blur(10px)'
          >
            <Text fontSize='sm' color='gray.600' fontWeight='medium'>
              شكراً لصبركم
            </Text>
            <Text fontSize='sm' color='gray.600' fontWeight='medium'>
              Thank you for your patience
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
